import {
  CategoryContainer,
  CategorySidebarContainer,
  ExpandIcon,
  FilterIconContainer,
  FilterName,
  NestingContainer,
  SelectableCategory,
} from "./CategorySidebarStyles";
import { TOP_LEVEL_CATEGORIES } from "../../../utils/categories";
import Icon from "../../common/Icon";
import React, { useState } from "react";
import { useUpdateSearch } from "../../../utils/hooks/partSearch";
import { Category } from "../../../reducers/models/categories";
import {
  BREAKPOINT,
  HideIfAboveWidth,
  ShowIfAboveWidth,
} from "../../../constants/Styles";
import FlashPCBCollapsible from "../../common/FlashPCBCollapsible";

const numSlashes = (path: string) => {
  return (path.match(/\//g) || []).length;
};

function CategorySidebarItem({
  nestingIndex,
  category,
  selectedCategory,
  categories,
}: {
  nestingIndex: number;
  category: Category;
  selectedCategory?: Category;
  categories: Category[];
}) {
  const selected = selectedCategory?.path.startsWith(category.path) || false;
  const [expanded, setExpanded] = useState(selected);

  const updateSearch = useUpdateSearch();
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const selectCategory = () => {
    setExpanded(true);
    updateSearch({
      updateSearchParameters: { categoryIds: [category.octopart_id], page: 1 },
    });
  };

  const iconStyleProps = expanded ? { transform: "rotate(180deg)" } : {};

  const categoryNumSlashes = numSlashes(category.path);
  const categoryChildren = categories.filter((maybeChild) => {
    if (maybeChild.path.startsWith(category.path)) {
      return numSlashes(maybeChild.path) == categoryNumSlashes + 1;
    }
    return false;
  });

  return (
    <NestingContainer nestingIndex={nestingIndex}>
      <CategoryContainer>
        <SelectableCategory selected={selected} onClick={selectCategory}>
          {category.name}
        </SelectableCategory>
        {categoryChildren.length > 0 && (
          <ExpandIcon onClick={toggleExpanded}>
            <Icon
              src={selected ? "/icons/expand.svg" : "/icons/expand_gray.svg"}
              alt="expand category"
              iconDimension={10}
              styleProps={iconStyleProps}
            />
          </ExpandIcon>
        )}
      </CategoryContainer>
      {expanded &&
        categoryChildren.map((categoryChild) => {
          return (
            <CategorySidebarItem
              key={categoryChild.octopart_id}
              nestingIndex={nestingIndex + 1}
              category={categoryChild}
              selectedCategory={selectedCategory}
              categories={categories}
            />
          );
        })}
    </NestingContainer>
  );
}

export default function CategorySidebar({
  categories,
  selectedCategoryIds,
}: {
  categories: Category[];
  selectedCategoryIds: string[];
}) {
  const selectedCategories = selectedCategoryIds.map((categoryId) =>
    categories.find((category) => category.octopart_id == categoryId),
  );
  const sidebar = TOP_LEVEL_CATEGORIES.map((category) => {
    const selectedCategory =
      selectedCategories.length == 1 ? selectedCategories[0] : undefined;
    return (
      <CategorySidebarItem
        key={category.name}
        nestingIndex={0}
        category={{
          octopart_id: category.id,
          name: category.name,
          path: category.path,
        }}
        selectedCategory={selectedCategory}
        categories={categories}
      />
    );
  });

  return (
    <CategorySidebarContainer>
      <HideIfAboveWidth width={BREAKPOINT}>
        <FlashPCBCollapsible
          renderTrigger={() => <FilterName>Category</FilterName>}
        >
          {sidebar}
        </FlashPCBCollapsible>
      </HideIfAboveWidth>
      <ShowIfAboveWidth width={BREAKPOINT}>
        <FilterIconContainer>
          <div>
            <Icon
              src={"/icons/filters.svg"}
              alt={"filter"}
              iconDimension={20}
            />
          </div>
          <FilterName>Category</FilterName>
        </FilterIconContainer>
        {sidebar}
      </ShowIfAboveWidth>
    </CategorySidebarContainer>
  );
}
